import { API_ENDPOINTS } from "../../../../Api/apiEndPoints";
import axiosInstance from "../../../../Api/axiosInstance";

// ✅ Get getCompanyConfiguration
export const getCompanyConfiguration = async (params: Record<string, any>) => {
    const response = await axiosInstance.get(
      API_ENDPOINTS.CONFIGURATION.GET_COMPANY_CONFIGURATION,
    );
    console.log(
      "🚀 ~ file: getCompanyConfiguration.ts ~ line 22 ~ getCompanyConfiguration ~ response",
      response.data
    );
    return response?.data;
  };
   // ✅ add or update CompanyConfiguration
   export const addOrUpdateCompanyConfiguration = async (body: {
   
   }) => {
     return axiosInstance.post(
       API_ENDPOINTS.CONFIGURATION.UPDATE_COMPANY_CONFIGURATION,
       body
     );
   };
// ✅ Get getAccessControls
export const getAccessControl = async (params: Record<string, any>) => {
    const response = await axiosInstance.get(
      API_ENDPOINTS.CONFIGURATION.GET_ACCESS_CONTROL,
    );
    console.log(
      "🚀 ~ file: getAccessControl.ts ~ line 22 ~ getAccessControl ~ response",
      response.data
    );
    return response?.data;
  };
  // ✅ add or update AccessControls
  export const addOrUpdateAccessControl = async (body: {
   
  }) => {
    return axiosInstance.post(
      API_ENDPOINTS.CONFIGURATION.UPDATE_ACCESS_CONTROL,
      body
    );
  };

  // ✅ Get ModuleWiseConfiguration
export const getModuleWiseConfiguration = async (id:any) => {
  const response = await axiosInstance.get(`${API_ENDPOINTS.CONFIGURATION.GET_MODULE_WISE_CONFIGURATION}/${id}`);
  console.log(
    "🚀 ~ file: getModuleWiseConfiguration.ts ~ line 22 ~ getModuleWiseConfiguration ~ response",
    response.data
  );
  return response?.data;
};
  // addorUpdate ModuleWiseConfiguration
  export const addOrUpdateModuleWiseConfiguration = async (id: number, body: Record<string, any>) => {
    const response = await axiosInstance.post(
      `${API_ENDPOINTS.CONFIGURATION.UPDATE_MODULE_WISE_CONFIGURATION}/${id}`,
      body
    );
    console.log("🚀 ~ AddOrUpdate Response:", response.data);
    return response?.data;
  };


  // Get WhenCanEmployeeSubmitExpenses
export const getWhenCanEmployeeSubmitExpenses = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.WHEN_CAN_EMPLOYEE_SUBMIT_EXPENSES);
  
  console.log(
    "🚀 ~ getWhenCanEmployeeSubmitExpenses ~line 35 ~ fetchWhenCanEmployeeSubmitExpenses ~  response:",
    response.data
  );

  return response?.data;
};
  // Get expenseReminder
export const getExpenseReminder = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.EXPENSE_REMINDER);
  
  console.log(
    "🚀 ~ getExpenseReminder ~line 35 ~ fetchExpenseReminder ~  response:",
    response.data
  );

  return response?.data;
};
  // Get tripApprovalRule
export const getTripApprovalRule = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.TRIP_APPROVAL_RULE);
  
  console.log(
    "🚀 ~ getTripApprovalRule ~line 35 ~ fetchTripApprovalRule ~  response:",
    response.data
  );

  return response?.data;
};
  // Get WhenCanExpensesBooked
export const getWhenCanExpensesBooked = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.WHEN_CAN_EXPENSES_BOOKED);
  
  console.log(
    "🚀 ~ getWhenCanExpensesBooked ~line 35 ~ WhenCanExpensesBooked ~  response:",
    response.data
  );

  return response?.data;
};
  // Get yesOrNo
export const getYesOrNo = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.YES_OR_NO);
  
  console.log(
    "🚀 ~ getyesOrNo ~line 35 ~ getyesOrNo ~  response:",
    response.data
  );

  return response?.data;
};
  // Get paymentSystem HOOK
export const getPaymentSystem = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.PAYMENT_SYSTEM);
  
  console.log(
    "🚀 ~ getPaymentSystem ~line 35 ~ PaymentSystem ~  response:",
    response.data
  );

  return response?.data;
};
  // Get autoCalculatedTa HOOK
export const getAutoCalculatedTa = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.CONFIGURATION.AUTO_CALCULATED_TA);
  
  console.log(
    "🚀 ~ getAutoCalculatedTa ~line 35 ~ autoCalculatedTa ~  response:",
    response.data
  );

  return response?.data;
};